import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from './config';
import { Order } from '../Models/order';
import { Observable } from 'rxjs/Observable';


/**
 * The OrderService creates an order and retrieves the order status
 */
@Injectable()
export class OrderService {

  constructor(
    private http: HttpClient,
    private config: Config
  ) {}

  public get(orderId): Observable<Order> {
    return this.http.get<Order>(this.config.base + '/orders/' + orderId + '/');
  }

  public createOrder(orderData): Observable<{}> {
    return this.http.post(
      this.config.getURL('ordercreate'),
      orderData,
    );
  }

  public create(order): Observable<Order> {
    return this.http.post<Order>(this.config.getURL('orders'), order);
  }

  public markReceived(order): Observable<Order> {
    return this.http.post<Order>(order._links.mark_received, {});
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/order.ts